module.exports = __webpack_public_path__ + "54fab3cade8c2ee0c58e58549e43bdee.png";